// Generated types for ItemUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ItemUsageReadAPI extends SysMLUsageReadAPI {
}

export interface ItemUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ItemUsageReadAPISchema: z.ZodType<ItemUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const ItemUsageWriteAPISchema: z.ZodType<ItemUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
